import {
  Alert,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { Ledamot } from '../../model/LedningDto';
import { ForetagTable } from '../ForetagTable/ForetagTable';
import { LedningMember } from './LedningMember';

interface LedningTableProps {
  ledningMembers: Ledamot[];
}

export const LedningTable: React.FC<LedningTableProps> = ({
  ledningMembers = [],
}) =>
  ledningMembers.length ? (
    <ForetagTable>
      <TableHead>
        <TableRow>
          <TableCell>Namn</TableCell>
          <TableCell>Roll</TableCell>
          <TableCell>Personnummer</TableCell>
          <TableCell>Registreringsdatum</TableCell>
          <TableCell>Bosatt</TableCell>
          <TableCell>Övriga engagemang</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {ledningMembers?.map((member) => (
          <LedningMember member={member} key={member.personnr} />
        ))}
      </TableBody>
    </ForetagTable>
  ) : (
    <Alert severity="info">Inga ledningsledamöter hittades.</Alert>
  );
